var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.40392157 0 0 0 0 0.11372549 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L19 0L19 19L0 19L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "editar",
    filter: "url(#filter_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L19 0L19 19L0 19L0 0Z",
    id: "Background",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0416 9.53669C14.6038 9.53669 14.25 9.8921 14.25 10.3299L14.25 16.6756C14.25 17.1127 13.8953 17.4688 13.4584 17.4688L2.375 17.4688C1.93795 17.4688 1.58338 17.1127 1.58338 16.6756L1.58338 5.57057C1.58338 5.13353 1.93795 4.7774 2.375 4.7774L8.70838 4.7774C9.14616 4.7774 9.5 4.42199 9.5 3.98423C9.5 3.54633 9.14616 3.19092 8.70838 3.19092L2.375 3.19092C1.06559 3.19092 0 4.25859 0 5.57057L0 16.6756C0 17.9876 1.06559 19.0553 2.375 19.0553L13.4584 19.0553C14.7678 19.0553 15.8334 17.9876 15.8334 16.6756L15.8334 10.3299C15.8334 9.89123 15.4794 9.53669 15.0416 9.53669L15.0416 9.53669Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42265 8.814C7.36727 8.86948 7.33002 8.94007 7.31422 9.01618L6.75453 11.8211C6.72844 11.9511 6.76961 12.0851 6.86296 12.1796C6.93819 12.2549 7.03952 12.2953 7.14331 12.2953C7.16853 12.2953 7.19477 12.293 7.22086 12.2875L10.0194 11.7267C10.097 11.7107 10.1674 11.6735 10.2221 11.6179L16.4857 5.34199L13.6872 2.53809L7.42265 8.814Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4205 0.598616C17.6488 -0.174799 16.3931 -0.174799 15.622 0.598616L14.5264 1.69636L17.3249 4.5004L18.4205 3.40252C18.7942 3.02895 19.0001 2.53077 19.0001 2.00093C19.0001 1.47109 18.7942 0.972905 18.4205 0.598616L18.4205 0.598616Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0e50ea324934e27a86961659f61f23cd.svg";
export { ForwardRef as ReactComponent };